const experimentUniverses = {
    CONCEPT_FUNNEL: "ConceptFunnel",
    RECAL_PRICE_REMOVAL: "NextGen_RecalPriceRemoval",
    MSR: "MSR",
    IGQ_SkipQuote: "NextGen_IGQSkipToInsurance",
    AFTERPAY_BREAKOUT_DISPLAY: "AfterpayBreakoutDisplay",
    MOBILE_FIRST_APPOINTMENT: "MobileFirstAppointment",
    MULTI_LOCATION_POPUP: "MultiLocationPopup",
    USE_SCHEDULING_PAGE: "UseSchedulingPage",
};

const experimentSettings = {
    GOOGLE_CUSTOM_DIMENSION_INDEX: "Google Custom Dimension Index",
    SUPPRESS_VIN_CAPTURE: "SuppressVinCapture",
    DISPLAY_AVAILABILITY_INDICATORS: "DisplayAvailabilityIndicators",
    PIA_EXPERIENCE: "PIA Experience",
    CONDITIONAL_PROVIDER_NUMBERS: "ConditionalProviderNumbers",
    CONDITIONAL_PROVIDER_NUMBERS_2: "ConditionalProviderNumbers2",
    CONDITIONAL_PROVIDER_SHUTOFF_DATE: "ConditionalProviderShutoffDate",
    PIA_INSURANCE: "DisplayPIAInsurance",
    SUBMIT_ORDER_ENABLE_PIA: "SubmitOrder_Enable_PIA",
    IS_EMAIL_OPTIONAL: "isEmailOptional",
    RECAL_PRICE_REMOVE: "RecalPriceRemove",
    INSURANCE_TAB_TO_DISPLAY_THRESHOLD_INTERNAL: "NextGen_InternalInsuranceTabDisplayThreshold",
    INSURANCE_TAB_TO_DISPLAY_THRESHOLD_EXTERNAL: "NextGen_ExternalInsuranceTabDisplayThreshold",
    DISPLAY_MSR: "DisplayMSR",
    ENABLE_MSR_SPLIT_PAY: "EnableMSRSplitPay",
    DISPLAY_WAITLIST: "DisplayWaitlist2.0",
    WAITLIST_THRESHOLD_DAYS: "Waitlist_Threshold_Days",
    PRICING_BY_DAY: "DisplayPricingByDay",
    FOSTER_LOVE: "DisplayFosterLove",
    SKIP_TO_INSURANCE: "SkipToInsurance",
    DISPLAY_AFTERPAY_BREAKOUT_DISPLAY: "Display_AfterpayBreakoutDisplay",
    AFTERPAY_EXTENDED_PAY_OPTION_THRESHOLD: "AfterPayExtendedPayOptionThreshold",
    DYNAMO_LOGGING: "DynamoLogging",
    SHOW_MOBILE_FIRST_APPT: "ShowMobileFirstAppt",
    SHOW_PM_MOBILE_DAYS: "Show_PMmobileDays",
    SHOW_NO_PM_MOBILE_DAYS: "Show_NoPMmobileDays",
    SHOW_NO_MOBILE_AVAILABLE_DAYS: "Show_NoMobileAvailableDays",
    SHOW_MOBILE_FIRST_POPUP_REPAIR: "Show_Mobile_First_Popup_Repair",
    SHOW_MOBILE_FIRST_POPUP_REPLACE_WITHOUT_MSR: "Show_Mobile_First_Popup_Replace_Without_MSR",
    SHOW_MOBILE_FIRST_POPUP_REPLACE_WITH_MSR: "Show_Mobile_First_Popup_Replace_With_MSR",
    OFFER_OEM: "OfferOem",
    SHOW_MULTI_LOCATION_APPT: "ShowMultiLocationAppt",
    SHOW_NO_AVAILABILE_DAYS_MULTI_LOCATION: "Show_NoAvailableDaysMultiLocation",
    SHOW_NO_PM_DAYS_MULTI_LOCATION: "Show_NoPMDaysMultiLocation",
    SHOW_PM_DAYS_MULTI_LOCATION: "Show_PMDaysMultiLocation",
    USE_ADYEN_PAYMENT: "UseAdyenPayment",
    SHOW_UNVERIFIED_DEDUCT_ENTRY: "ShowUnverifiedDeducEntry",
    SERVICE_PACKAGE_ORDER: "ServicePackageOrder",
    USE_SCHEDULING_PAGE: "UseSchedulingPage",
    USE_PIA12: "UsePIA12",

    // Claim and Coverage for 2.0
    ENABLE_NON_CLAIM_AND_COVERAGE_FLOW: "EnableNonC&CFlow",
    NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT: "NonC&CTestParentAccount",

    // Service Package Name
    SHOW_SERVICE_PACKAGE_NAME_TEST: "ShowServicePackageNameTest",
    TIER_ONE: "TierOne",
    TIER_TWO: "TierTwo",
    TIER_THREE: "TierThree",
    TIER_TWO_DESCRIPTION: "TierTwo_Description",
    TIER_THREE_DESCRIPTION: "TierThree_Description",

    // Promo Banner
    SHOW_PROMO_BANNER: "ShowQuotePageRegionalPromoBanner",

    // User Core Services Part Service
    USER_CORE_SERVICES_PART_SERVICE: "UserCoreServicesPartService",

    // User Core Services Location Service
    USER_CORE_SERVICES_LOCATION_SERVICE: "UserCoreServicesLocationService",
};

const experimentTriggers = {
    SITE_ENTRY: "SiteEntry",
    PAGE_ENTRY: "PageEntry",
};

export { experimentUniverses, experimentSettings, experimentTriggers };
